/* eslint-disable sonarjs/no-duplicate-string */
export const COUNTRY_CODE_CZ = 'CZ';
export const COUNTRY_CODE_SK = 'SK';
export const COUNTRY_CODE_HU = 'HU';

/**
 * @copyright Michael Wittig
 * @see {@link https://github.com/michaelwittig/node-i18n-iso-countries/blob/master/langs/cs.json}
 */

// EU Countries
export const isoEuCountries = {
	cs: {
		BE: 'Belgie',
		BG: 'Bulharsko',
		CZ: 'Česká republika',
		DK: 'Dánsko',
		EE: 'Estonsko',
		FI: 'Finsko',
		FR: 'Francie',
		HR: 'Chorvatsko',
		IE: 'Irsko',
		IT: 'Itálie',
		CY: 'Kypr',
		LT: 'Litva',
		LV: 'Lotyšsko',
		LU: 'Lucembursko',
		HU: 'Maďarsko',
		MT: 'Malta',
		DE: 'Německo',
		NL: 'Nizozemsko',
		PL: 'Polsko',
		PT: 'Portugalsko',
		AT: 'Rakousko',
		RO: 'Rumunsko',
		GR: 'Řecko',
		SK: 'Slovensko',
		SI: 'Slovinsko',
		ES: 'Španělsko',
		SE: 'Švédsko',
	},
	sk: {
		BE: 'Belgicko',
		BG: 'Bulharsko',
		CZ: 'Česko',
		DK: 'Dánsko',
		EE: 'Estónsko',
		FI: 'Fínsko',
		FR: 'Francúzsko',
		HR: 'Chorvátsko',
		IE: 'Írsko',
		IT: 'Taliansko',
		CY: 'Cyprus',
		LT: 'Litva',
		LV: 'Lotyšsko',
		LU: 'Luxembursko',
		HU: 'Maďarsko',
		MT: 'Malta',
		DE: 'Nemecko',
		NL: 'Holandsko',
		PL: 'Poľsko',
		PT: 'Portugalsko',
		AT: 'Rakúsko',
		RO: 'Rumunsko',
		GR: 'Grécko',
		SK: 'Slovensko',
		SI: 'Slovinsko',
		ES: 'Španielsko',
		SE: 'Švédsko',
	},
	hu: {
		BE: 'Belgium',
		BG: 'Bulgária',
		CZ: 'Csehország',
		DK: 'Dánia',
		EE: 'Észtország',
		FI: 'Finnország',
		FR: 'Franciaország',
		HR: 'Horvátország',
		IE: 'Írország',
		IT: 'Olaszország',
		CY: 'Ciprus',
		LT: 'Litvánia',
		LV: 'Lettország',
		LU: 'Luxemburg',
		HU: 'Magyarország',
		MT: 'Málta',
		DE: 'Németország',
		NL: 'Hollandia',
		PL: 'Lengyelország',
		PT: 'Portugália',
		AT: 'Ausztria',
		RO: 'Románia',
		GR: 'Görögország',
		SK: 'Szlovákia',
		SI: 'Szlovénia',
		ES: 'Spanyolország',
		SE: 'Svédország',
	},
};

// All Countries
export const isoCountries = {
	cs: {
		AF: 'Afghánistán',
		AX: 'Ålandy',
		AL: 'Albánie',
		DZ: 'Alžírsko',
		AS: 'Americká Samoa',
		VI: 'Americké Panenské ostrovy',
		AD: 'Andorra',
		AO: 'Angola',
		AI: 'Anguilla',
		AQ: 'Antarktida',
		AG: 'Antigua a Barbuda',
		AR: 'Argentina',
		AM: 'Arménie',
		AW: 'Aruba',
		AU: 'Austrálie',
		AZ: 'Ázerbájdžán',
		BS: 'Bahamy',
		BH: 'Bahrajn',
		BD: 'Bangladéš',
		BB: 'Barbados',
		BE: 'Belgie',
		BZ: 'Belize',
		BY: 'Bělorusko',
		BJ: 'Benin',
		BM: 'Bermudy',
		BT: 'Bhútán',
		BO: 'Bolívie',
		BQ: 'Bonaire, Svatý Eustach a Saba',
		BA: 'Bosna a Hercegovina',
		BW: 'Botswana',
		BV: 'Bouvetův ostrov',
		BR: 'Brazílie',
		IO: 'Britské indickooceánské území',
		VG: 'Britské Panenské ostrovy',
		BN: 'Brunej',
		BG: 'Bulharsko',
		BF: 'Burkina Faso',
		BI: 'Burundi',
		CK: 'Cookovy ostrovy',
		CW: 'Curaçao',
		TD: 'Čad',
		ME: 'Černá Hora',
		CZ: 'Česká republika',
		CN: 'Čína',
		DK: 'Dánsko',
		CD: 'Demokratická republika Kongo',
		DM: 'Dominika',
		DO: 'Dominikánská republika',
		DJ: 'Džibutsko',
		EG: 'Egypt',
		EC: 'Ekvádor',
		ER: 'Eritrea',
		EE: 'Estonsko',
		ET: 'Etiopie',
		FO: 'Faerské ostrovy',
		FK: 'Falklandy (Malvíny)',
		FJ: 'Fidži',
		PH: 'Filipíny',
		FI: 'Finsko',
		FR: 'Francie',
		GF: 'Francouzská Guyana',
		TF: 'Francouzská jižní a antarktická území',
		PF: 'Francouzská Polynésie',
		GA: 'Gabon',
		GM: 'Gambie',
		GH: 'Ghana',
		GI: 'Gibraltar',
		GD: 'Grenada',
		GL: 'Grónsko',
		GE: 'Gruzie',
		GP: 'Guadeloupe',
		GU: 'Guam',
		GT: 'Guatemala',
		GN: 'Guinea',
		GW: 'Guinea-Bissau',
		GG: 'Guernsey',
		GY: 'Guyana',
		HT: 'Haiti',
		HM: 'Heardův ostrov a McDonaldovy ostrovy',
		HN: 'Honduras',
		HK: 'Hongkong',
		CL: 'Chile',
		HR: 'Chorvatsko',
		IN: 'Indie',
		ID: 'Indonésie',
		IQ: 'Irák',
		IR: 'Írán',
		IE: 'Irsko',
		IS: 'Island',
		IT: 'Itálie',
		IL: 'Izrael',
		JM: 'Jamajka',
		JP: 'Japonsko',
		YE: 'Jemen',
		JE: 'Jersey',
		ZA: 'Jihoafrická republika',
		GS: 'Jižní Georgie a Jižní Sandwichovy ostrovy',
		KR: 'Jižní Korea',
		SS: 'Jižní Súdán',
		JO: 'Jordánsko',
		KY: 'Kajmanské ostrovy',
		KH: 'Kambodža',
		CM: 'Kamerun',
		CA: 'Kanada',
		CV: 'Kapverdy',
		QA: 'Katar',
		KZ: 'Kazachstán',
		KE: 'Keňa',
		KI: 'Kiribati',
		CC: 'Kokosové ostrovy',
		CO: 'Kolumbie',
		KM: 'Komory',
		CG: 'Kongo',
		CR: 'Kostarika',
		CU: 'Kuba',
		KW: 'Kuvajt',
		CY: 'Kypr',
		KG: 'Kyrgyzstán',
		LA: 'Laos',
		LS: 'Lesotho',
		LB: 'Libanon',
		LR: 'Libérie',
		LY: 'Libye',
		LI: 'Lichtenštejnsko',
		LT: 'Litva',
		LV: 'Lotyšsko',
		LU: 'Lucembursko',
		MO: 'Macao',
		MG: 'Madagaskar',
		HU: 'Maďarsko',
		MY: 'Malajsie',
		MW: 'Malawi',
		MV: 'Maledivy',
		ML: 'Mali',
		MT: 'Malta',
		IM: 'Ostrov Man',
		MA: 'Maroko',
		MH: 'Marshallovy ostrovy',
		MQ: 'Martinik',
		MU: 'Mauricius',
		MR: 'Mauritánie',
		YT: 'Mayotte',
		UM: 'Menší odlehlé ostrovy USA',
		MX: 'Mexiko',
		FM: 'Mikronésie',
		MD: 'Moldavsko',
		MC: 'Monako',
		MN: 'Mongolsko',
		MS: 'Montserrat',
		MZ: 'Mosambik',
		MM: 'Myanmar',
		NA: 'Namibie',
		NR: 'Nauru',
		DE: 'Německo',
		NP: 'Nepál',
		NE: 'Niger',
		NG: 'Nigérie',
		NI: 'Nikaragua',
		NU: 'Niue',
		NL: 'Nizozemsko',
		NF: 'Norfolk',
		NO: 'Norsko',
		NC: 'Nová Kaledonie',
		NZ: 'Nový Zéland',
		OM: 'Omán',
		PK: 'Pákistán',
		PW: 'Palau',
		PS: 'Palestinská autonomie',
		PA: 'Panama',
		PG: 'Papua-Nová Guinea',
		PY: 'Paraguay',
		PE: 'Peru',
		PN: 'Pitcairnovy ostrovy',
		CI: 'Pobřeží slonoviny',
		PL: 'Polsko',
		PR: 'Portoriko',
		PT: 'Portugalsko',
		AT: 'Rakousko',
		RE: 'Réunion',
		GQ: 'Rovníková Guinea',
		RO: 'Rumunsko',
		RU: 'Rusko',
		RW: 'Rwanda',
		GR: 'Řecko',
		PM: 'Saint-Pierre a Miquelon',
		SV: 'Salvador',
		WS: 'Samoa',
		SM: 'San Marino',
		SA: 'Saúdská Arábie',
		SN: 'Senegal',
		KP: 'Severní Korea',
		MK: 'Severní Makedonie',
		MP: 'Severní Mariany',
		SC: 'Seychely',
		SL: 'Sierra Leone',
		SG: 'Singapur',
		SK: 'Slovensko',
		SI: 'Slovinsko',
		SO: 'Somálsko',
		AE: 'Spojené arabské emiráty',
		GB: 'Spojené království',
		US: 'Spojené státy americké',
		RS: 'Srbsko',
		CF: 'Středoafrická republika',
		SD: 'Súdán',
		SR: 'Surinam',
		SH: 'Svatá Helena, Ascension a Tristan da Cunha',
		LC: 'Svatá Lucie',
		BL: 'Svatý Bartoloměj',
		KN: 'Svatý Kryštof a Nevis',
		MF: 'Svatý Martin (francouzská část)',
		SX: 'Svatý Martin (nizozemská část)',
		ST: 'Svatý Tomáš a Princův ostrov',
		VC: 'Svatý Vincenc a Grenadiny',
		SZ: 'Svazijsko',
		SY: 'Sýrie',
		SB: 'Šalamounovy ostrovy',
		ES: 'Španělsko',
		SJ: 'Špicberky a Jan Mayen',
		LK: 'Šrí Lanka',
		SE: 'Švédsko',
		CH: 'Švýcarsko',
		TJ: 'Tádžikistán',
		TZ: 'Tanzanie',
		TH: 'Thajsko',
		TW: 'Tchaj-wan',
		TG: 'Togo',
		TK: 'Tokelau',
		TO: 'Tonga',
		TT: 'Trinidad a Tobago',
		TN: 'Tunisko',
		TR: 'Turecko',
		TM: 'Turkmenistán',
		TC: 'Turks a Caicos',
		TV: 'Tuvalu',
		UG: 'Uganda',
		UA: 'Ukrajina',
		UY: 'Uruguay',
		UZ: 'Uzbekistán',
		CX: 'Vánoční ostrov',
		VU: 'Vanuatu',
		VA: 'Vatikán',
		VE: 'Venezuela',
		VN: 'Vietnam',
		TL: 'Východní Timor',
		WF: 'Wallis a Futuna',
		ZM: 'Zambie',
		EH: 'Západní Sahara',
		ZW: 'Zimbabwe',
		XK: 'Kosovo',
	},
	sk: {
		AD: 'Andorra',
		AE: 'Spojené arabské emiráty',
		AF: 'Afganistan',
		AG: 'Antigua a Barbuda',
		AI: 'Anguilla',
		AL: 'Albánsko',
		AM: 'Arménsko',
		AO: 'Angola',
		AQ: 'Antarktída',
		AR: 'Argentína',
		AS: 'Americká Samoa',
		AT: 'Rakúsko',
		AU: 'Austrália',
		AW: 'Aruba',
		AX: 'Alandy',
		AZ: 'Azerbajdžan',
		BA: 'Bosna a Hercegovina',
		BB: 'Barbados',
		BD: 'Bangladéš',
		BE: 'Belgicko',
		BF: 'Burkina Faso',
		BG: 'Bulharsko',
		BH: 'Bahrajn',
		BI: 'Burundi',
		BJ: 'Benin',
		BL: 'Svätý Bartolomej',
		BM: 'Bermudy',
		BN: 'Brunej',
		BO: 'Bolívia',
		BQ: 'Karibské Holandsko',
		BR: 'Brazília',
		BS: 'Bahamy',
		BT: 'Bhután',
		BV: 'Bouvetov ostrov',
		BW: 'Botswana',
		BY: 'Bielorusko',
		BZ: 'Belize',
		CA: 'Kanada',
		CC: 'Kokosové ostrovy',
		CD: 'Konžská demokratická republika',
		CF: 'Stredoafrická republika',
		CG: 'Konžská republika',
		CH: 'Švajčiarsko',
		CI: 'Pobrežie Slonoviny',
		CK: 'Cookove ostrovy',
		CL: 'Čile',
		CM: 'Kamerun',
		CN: 'Čína',
		CO: 'Kolumbia',
		CR: 'Kostarika',
		CU: 'Kuba',
		CV: 'Kapverdy',
		CW: 'Curaçao',
		CX: 'Vianočný ostrov',
		CY: 'Cyprus',
		CZ: 'Česko',
		DE: 'Nemecko',
		DJ: 'Džibutsko',
		DK: 'Dánsko',
		DM: 'Dominika',
		DO: 'Dominikánska republika',
		DZ: 'Alžírsko',
		EC: 'Ekvádor',
		EE: 'Estónsko',
		EG: 'Egypt',
		EH: 'Západná Sahara',
		ER: 'Eritrea',
		ES: 'Španielsko',
		ET: 'Etiópia',
		FI: 'Fínsko',
		FJ: 'Fidži',
		FK: 'Falklandy',
		FM: 'Mikronézia',
		FO: 'Faerské ostrovy',
		FR: 'Francúzsko',
		GA: 'Gabon',
		GB: 'Spojené kráľovstvo',
		GD: 'Grenada',
		GE: 'Gruzínsko',
		GF: 'Francúzska Guayana',
		GG: 'Guernsey',
		GH: 'Ghana',
		GI: 'Gibraltár',
		GL: 'Grónsko',
		GM: 'Gambia',
		GN: 'Guinea',
		GP: 'Guadeloupe',
		GQ: 'Rovníková Guinea',
		GR: 'Grécko',
		GS: 'Južná Georgia a Južné Sandwichove ostrovy',
		GT: 'Guatemala',
		GU: 'Guam',
		GW: 'Guinea-Bissau',
		GY: 'Guayana',
		HK: 'Hongkong – OAO Číny',
		HM: 'Heardov ostrov a Macdonaldove ostrovy',
		HN: 'Honduras',
		HR: 'Chorvátsko',
		HT: 'Haiti',
		HU: 'Maďarsko',
		ID: 'Indonézia',
		IE: 'Írsko',
		IL: 'Izrael',
		IM: 'Ostrov Man',
		IN: 'India',
		IO: 'Britské indickooceánske územie',
		IQ: 'Irak',
		IR: 'Irán',
		IS: 'Island',
		IT: 'Taliansko',
		JE: 'Jersey',
		JM: 'Jamajka',
		JO: 'Jordánsko',
		JP: 'Japonsko',
		KE: 'Keňa',
		KG: 'Kirgizsko',
		KH: 'Kambodža',
		KI: 'Kiribati',
		KM: 'Komory',
		KN: 'Svätý Krištof a Nevis',
		KP: 'Severná Kórea',
		KR: 'Južná Kórea',
		KW: 'Kuvajt',
		KY: 'Kajmanie ostrovy',
		KZ: 'Kazachstan',
		LA: 'Laos',
		LB: 'Libanon',
		LC: 'Svätá Lucia',
		LI: 'Lichtenštajnsko',
		LK: 'Srí Lanka',
		LR: 'Libéria',
		LS: 'Lesotho',
		LT: 'Litva',
		LU: 'Luxembursko',
		LV: 'Lotyšsko',
		LY: 'Líbya',
		MA: 'Maroko',
		MC: 'Monako',
		MD: 'Moldavsko',
		ME: 'Čierna Hora',
		MF: 'Svätý Martin (fr.)',
		MG: 'Madagaskar',
		MH: 'Marshallove ostrovy',
		MK: 'Severné Macedónsko',
		ML: 'Mali',
		MM: 'Mjanmarsko',
		MN: 'Mongolsko',
		MO: 'Macao – OAO Číny',
		MP: 'Severné Mariány',
		MQ: 'Martinik',
		MR: 'Mauritánia',
		MS: 'Montserrat',
		MT: 'Malta',
		MU: 'Maurícius',
		MV: 'Maldivy',
		MW: 'Malawi',
		MX: 'Mexiko',
		MY: 'Malajzia',
		MZ: 'Mozambik',
		NA: 'Namíbia',
		NC: 'Nová Kaledónia',
		NE: 'Niger',
		NF: 'Norfolk',
		NG: 'Nigéria',
		NI: 'Nikaragua',
		NL: 'Holandsko',
		NO: 'Nórsko',
		NP: 'Nepál',
		NR: 'Nauru',
		NU: 'Niue',
		NZ: 'Nový Zéland',
		OM: 'Omán',
		PA: 'Panama',
		PE: 'Peru',
		PF: 'Francúzska Polynézia',
		PG: 'Papua Nová Guinea',
		PH: 'Filipíny',
		PK: 'Pakistan',
		PL: 'Poľsko',
		PM: 'Saint Pierre a Miquelon',
		PN: 'Pitcairnove ostrovy',
		PR: 'Portoriko',
		PS: 'Palestínske územia',
		PT: 'Portugalsko',
		PW: 'Palau',
		PY: 'Paraguaj',
		QA: 'Katar',
		RE: 'Réunion',
		RO: 'Rumunsko',
		RS: 'Srbsko',
		RU: 'Rusko',
		RW: 'Rwanda',
		SA: 'Saudská Arábia',
		SB: 'Šalamúnove ostrovy',
		SC: 'Seychely',
		SD: 'Sudán',
		SE: 'Švédsko',
		SG: 'Singapur',
		SH: 'Svätá Helena',
		SI: 'Slovinsko',
		SJ: 'Svalbard a Jan Mayen',
		SK: 'Slovensko',
		SL: 'Sierra Leone',
		SM: 'San Maríno',
		SN: 'Senegal',
		SO: 'Somálsko',
		SR: 'Surinam',
		SS: 'Južný Sudán',
		ST: 'Svätý Tomáš a Princov ostrov',
		SV: 'Salvádor',
		SX: 'Svätý Martin (hol.)',
		SY: 'Sýria',
		SZ: 'Svazijsko',
		TC: 'Turks a Caicos',
		TD: 'Čad',
		TF: 'Francúzske južné a antarktické územia',
		TG: 'Togo',
		TH: 'Thajsko',
		TJ: 'Tadžikistan',
		TK: 'Tokelau',
		TL: 'Východný Timor',
		TM: 'Turkménsko',
		TN: 'Tunisko',
		TO: 'Tonga',
		TR: 'Turecko',
		TT: 'Trinidad a Tobago',
		TV: 'Tuvalu',
		TW: 'Taiwan',
		TZ: 'Tanzánia',
		UA: 'Ukrajina',
		UG: 'Uganda',
		UM: 'Menšie odľahlé ostrovy USA',
		US: 'Spojené štáty',
		UY: 'Uruguaj',
		UZ: 'Uzbekistan',
		VA: 'Vatikán',
		VC: 'Svätý Vincent a Grenadíny',
		VE: 'Venezuela',
		VG: 'Britské Panenské ostrovy',
		VI: 'Americké Panenské ostrovy',
		VN: 'Vietnam',
		VU: 'Vanuatu',
		WF: 'Wallis a Futuna',
		WS: 'Samoa',
		XK: 'Kosovo',
		YE: 'Jemen',
		YT: 'Mayotte',
		ZA: 'Južná Afrika',
		ZM: 'Zambia',
		ZW: 'Zimbabwe',
	},
	hu: {
		AD: 'Andorra',
		AE: 'Egyesült Arab Emírségek',
		AF: 'Afganisztán',
		AG: 'Antigua és Barbuda',
		AI: 'Anguilla',
		AL: 'Albánia',
		AM: 'Örményország',
		AO: 'Angola',
		AQ: 'Antarktisz',
		AR: 'Argentína',
		AS: 'Amerikai Szamoa',
		AT: 'Ausztria',
		AU: 'Ausztrália',
		AW: 'Aruba',
		AX: 'Åland-szigetek',
		AZ: 'Azerbajdzsán',
		BA: 'Bosznia-Hercegovina',
		BB: 'Barbados',
		BD: 'Banglades',
		BE: 'Belgium',
		BF: 'Burkina Faso',
		BG: 'Bulgária',
		BH: 'Bahrein',
		BI: 'Burundi',
		BJ: 'Benin',
		BL: 'Szent Bertalan-sziget',
		BM: 'Bermuda',
		BN: 'Brunei',
		BO: 'Bolívia',
		BQ: 'Karib-térség Holland része',
		BR: 'Brazília',
		BS: 'Bahama-szigetek',
		BT: 'Bhután',
		BV: 'Bouvet-sziget',
		BW: 'Botswana',
		BY: 'Fehéroroszország',
		BZ: 'Belize',
		CA: 'Kanada',
		CC: 'Kókusz-szigetek',
		CD: 'Kongói Demokratikus Köztársaság',
		CF: 'Közép-afrikai Köztársaság',
		CG: 'Kongói Köztársaság',
		CH: 'Svájc',
		CI: 'Elefántcsontpart',
		CK: 'Cook-szigetek',
		CL: 'Chile',
		CM: 'Kamerun',
		CN: 'Kína',
		CO: 'Kolumbia',
		CR: 'Costa Rica',
		CU: 'Kuba',
		CV: 'Zöld-foki Köztársaság',
		CW: 'Curaçao',
		CX: 'Karácsony-sziget',
		CY: 'Ciprus',
		CZ: 'Csehország',
		DE: 'Németország',
		DJ: 'Dzsibuti',
		DK: 'Dánia',
		DM: 'Dominika',
		DO: 'Dominikai Köztársaság',
		DZ: 'Algéria',
		EC: 'Ecuador',
		EE: 'Észtország',
		EG: 'Egyiptom',
		EH: 'Nyugat-Szahara',
		ER: 'Eritrea',
		ES: 'Spanyolország',
		ET: 'Etiópia',
		FI: 'Finnország',
		FJ: 'Fidzsi-szigetek',
		FK: 'Falkland-szigetek (Malvín-szigetek)',
		FM: 'Mikronézia',
		FO: 'Feröer-szigetek',
		FR: 'Franciaország',
		GA: 'Gabon',
		GB: 'Egyesült Királyság',
		GD: 'Grenada',
		GE: 'Grúzia',
		GF: 'Francia Guyana',
		GG: 'Guernsey',
		GH: 'Ghána',
		GI: 'Gibraltár',
		GL: 'Grönland',
		GM: 'Gambia',
		GN: 'Guinea',
		GP: 'Guadeloupe',
		GQ: 'Egyenlítői Guinea',
		GR: 'Görögország',
		GS: 'Déli Georgia és Déli Sandwich-szigetek',
		GT: 'Guatemala',
		GU: 'Guam',
		GW: 'Guinea-Bissau',
		GY: 'Guyana',
		HK: 'Hongkong – Kína különleges közigazgatási területe',
		HM: 'Heard-sziget és McDonald-szigetek',
		HN: 'Honduras',
		HR: 'Horvátország',
		HT: 'Haiti',
		HU: 'Magyarország',
		ID: 'Indonézia',
		IE: 'Írország',
		IL: 'Izrael',
		IM: 'Man-sziget',
		IN: 'India',
		IO: 'Brit Indiai-óceáni Terület',
		IQ: 'Irak',
		IR: 'Irán',
		IS: 'Izland',
		IT: 'Olaszország',
		JE: 'Jersey',
		JM: 'Jamaica',
		JO: 'Jordánia',
		JP: 'Japán',
		KE: 'Kenya',
		KG: 'Kirgizisztán',
		KH: 'Kambodzsa',
		KI: 'Kiribati',
		KM: 'Comore-szigetek',
		KN: 'Szent Kitts és Nevis',
		KP: 'Észak-Korea',
		KR: 'Dél-Korea',
		KW: 'Kuvait',
		KY: 'Kajmán-szigetek',
		KZ: 'Kazahsztán',
		LA: 'Laosz',
		LB: 'Libanon',
		LC: 'Saint Lucia',
		LI: 'Liechtenstein',
		LK: 'Srí Lanka',
		LR: 'Libéria',
		LS: 'Lesotho',
		LT: 'Litvánia',
		LU: 'Luxemburg',
		LV: 'Lettország',
		LY: 'Líbia',
		MA: 'Marokkó',
		MC: 'Monaco',
		MD: 'Moldova',
		ME: 'Montenegró',
		MF: 'Szent Martin (francia rész)',
		MG: 'Madagaszkár',
		MH: 'Marshall-szigetek',
		MK: 'Észak-Macedónia',
		ML: 'Mali',
		MM: 'Mianmar',
		MN: 'Mongólia',
		MO: 'Makaó – Kína különleges közigazgatási területe',
		MP: 'Északi Mariana-szigetek',
		MQ: 'Martinique',
		MR: 'Mauritánia',
		MS: 'Montserrat',
		MT: 'Málta',
		MU: 'Mauritius',
		MV: 'Maldív-szigetek',
		MW: 'Malawi',
		MX: 'Mexikó',
		MY: 'Malajzia',
		MZ: 'Mozambik',
		NA: 'Namíbia',
		NC: 'Új-Kaledónia',
		NE: 'Niger',
		NF: 'Norfolk-sziget',
		NG: 'Nigéria',
		NI: 'Nicaragua',
		NL: 'Hollandia',
		NO: 'Norvégia',
		NP: 'Nepál',
		NR: 'Nauru',
		NU: 'Niue',
		NZ: 'Új-Zéland',
		OM: 'Omán',
		PA: 'Panama',
		PE: 'Peru',
		PF: 'Francia Polinézia',
		PG: 'Pápua Új-Guinea',
		PH: 'Fülöp-szigetek',
		PK: 'Pakisztán',
		PL: 'Lengyelország',
		PM: 'Saint Pierre és Miquelon',
		PN: 'Pitcairn-szigetek',
		PR: 'Puerto Rico',
		PS: 'Palesztin Terület',
		PT: 'Portugália',
		PW: 'Palau',
		PY: 'Paraguay',
		QA: 'Katar',
		RE: 'Réunion',
		RO: 'Románia',
		RS: 'Szerbia',
		RU: 'Oroszország',
		RW: 'Ruanda',
		SA: 'Szaúd-Arábia',
		SB: 'Salamon-szigetek',
		SC: 'Seychelle-szigetek',
		SD: 'Szudán',
		SE: 'Svédország',
		SG: 'Szingapúr',
		SH: 'Szent Ilona, Ascension és Tristan da Cunha',
		SI: 'Szlovénia',
		SJ: 'Svalbard és Jan Mayen',
		SK: 'Szlovákia',
		SL: 'Sierra Leone',
		SM: 'San Marino',
		SN: 'Szenegál',
		SO: 'Szomália',
		SR: 'Suriname',
		SS: 'Dél-Szudán',
		ST: 'São Tomé és Príncipe',
		SV: 'Salvador',
		SX: 'Szent Martin (holland rész)',
		SY: 'Szíria',
		SZ: 'Szváziföld',
		TC: 'Turks- és Caicos-szigetek',
		TD: 'Csád',
		TF: 'Francia Déli és Antarktiszi Területek',
		TG: 'Togo',
		TH: 'Thaiföld',
		TJ: 'Tádzsikisztán',
		TK: 'Tokelau',
		TL: 'Kelet-Timor',
		TM: 'Türkmenisztán',
		TN: 'Tunézia',
		TO: 'Tonga',
		TR: 'Törökország',
		TT: 'Trinidad és Tobago',
		TV: 'Tuvalu',
		TW: 'Tajvan',
		TZ: 'Tanzánia',
		UA: 'Ukrajna',
		UG: 'Uganda',
		UM: 'Az Amerikai Egyesült Államok lakatlan külbirtokai',
		US: 'Amerikai Egyesült Államok',
		UY: 'Uruguay',
		UZ: 'Üzbegisztán',
		VA: 'Vatikán',
		VC: 'Szent Vincent és a Grenadine-szigetek',
		VE: 'Venezuela',
		VG: 'Brit Virgin-szigetek',
		VI: 'Amerikai Virgin-szigetek',
		VN: 'Vietnám',
		VU: 'Vanuatu',
		WF: 'Wallis és Futuna',
		WS: 'Szamoa',
		XK: 'Koszovó',
		YE: 'Jemen',
		YT: 'Mayotte',
		ZA: 'Dél-Afrika',
		ZM: 'Zambia',
		ZW: 'Zimbabwe',
	},
};
